export default __webpack_public_path__ + "static/media/AvenirHeavyFont.f728da1a.ttf";